import * as yup from 'yup';
import {
  MAX_FILE_SIZE_IN_MB_ID_VERIFY,
  ATTACHMENT_SUPPORTED_FORMATS,
  ATTACHMENT_MAX_FILE_NAME_LENGTH,
} from '../../../constants';

const maxFileSize = MAX_FILE_SIZE_IN_MB_ID_VERIFY * 1048576;

function uploaderValidations() {
  return yup.array().of(
    yup
      .mixed()
      .test('maxFileSize', `The maximum file size allowed is ${maxFileSize}MB`, (value) => {
        const isValid = value && value.size <= maxFileSize * 1024 * 1024;
        return isValid;
      })
      .test('fileSize', 'The file must not be empty', (value) => {
        const isValid = value && value.size > 0;
        return isValid;
      })
      .test(
        'fileFormat',
        `The supported file types are ${ATTACHMENT_SUPPORTED_FORMATS.toString()}`,
        (value) => value && ATTACHMENT_SUPPORTED_FORMATS.includes(value.type),
      )
      .test(
        'fileName',
        `The maximum length of a file name is ${ATTACHMENT_MAX_FILE_NAME_LENGTH} characters`,
        (value) => value.name.length <= ATTACHMENT_MAX_FILE_NAME_LENGTH,
      ),
  );
}

export const validationSchemaUploadId = yup.object().shape({
  isAMLPEPPassed: yup.bool(),
  medicareDocumentFiles: yup.array().when(['isAMLPEPPassed'], {
    is: (isAMLPEPPassed) => !isAMLPEPPassed,
    then: uploaderValidations(),
  }),
  passportDocumentFiles: uploaderValidations(),
  driversLicenceDocumentFiles: uploaderValidations(),
});
